import React, { ReactNode } from 'react';
import { Like16 as IconSocialLikeOn16 } from '@cian/ui-kit';

import * as s from './Label.css';

export interface ILabel {
  children: ReactNode;
}

/**
 * Компонент для величины рейтинга
 */
export const Label = ({ children }: ILabel) => (
  <div className={s['wrapper']}>
    <IconSocialLikeOn16 />
    {children}
  </div>
);
